import { render, staticRenderFns } from "./AnagraficheDettaglioTipologia.vue?vue&type=template&id=384d7ae2&scoped=true&"
import script from "./AnagraficheDettaglioTipologia.vue?vue&type=script&lang=js&"
export * from "./AnagraficheDettaglioTipologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d7ae2",
  null
  
)

export default component.exports